<template>
  <div class="themeItem_mode_6" v-if="list">
    <EVENTCOP_MODE_6
      :themeClass="'onlyDisplay'"
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :sportsTypeArr="sportsTypeArr"
      :currSportsDetail="currSportsDetail"
      :datas="list"
      :modeType="'double'"
    />
  </div>
</template>

<script>
//  汤尤杯【本场数据中单场比赛的表格展示】 播出单的主题；运动员名字拼接因此选择 competitorType = D
import cup_base_data_mixin from '@mixins/cup_base_data'
import EVENTCOP_MODE_6 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_6.vue'
export default {
  name: 'themeItem_mode_6',
  mixins: [cup_base_data_mixin],
  components: {
    EVENTCOP_MODE_6,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      list: null,
    }
  },
  watch: {
    datas(newVal, oldVal) {
      if (
        newVal &&
        (JSON.stringify(newVal.data.dataList) !==
          JSON.stringify(oldVal.data.dataList) ||
          JSON.stringify(newVal.objectInfo) !==
            JSON.stringify(oldVal.objectInfo))
      ) {
        this.list = this.computedMatchList(newVal)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.list = this.computedMatchList(this.datas)
  },
  methods: {
    computedMatchList(datas) {
      console.debug('themeItem_mode_6:', this.datas)
      let eventCompModeDatas = {
        home: {},
        away: {},
        table_head: [],
      }
      if (datas.data.dataList && datas.data.dataList.length > 0) {
        const dataArr = []
        datas.objectInfo.forEach((item, itemIndex) => {
          let score_detail = []
          datas.data.dataList[itemIndex].forEach((unit) => {
            score_detail.push({
              periodCode: unit.periodCode,
              periodName: unit.periodName,
              periodScore: unit.periodScore,
            })
          })
          let players = item.playerInfos.map((player) => {
            return {
              player_id: player.playerId,
              player_name: player.playerName,
              player_logo: player.profilePicture,
              player_gender: 'M',
              team_id: item.teamId,
              team_name: item.teamName,
              team_logo: item.teamLogo,
            }
          })
          // if (players && players.length === 1) {
          //   players.push({
          //     player_id: '',
          //     player_name: '',
          //     player_logo: '',
          //     player_gender: 'M',
          //     team_id: '',
          //     team_name: '',
          //     team_logo: '',
          //   })
          // }
          let baseItem = {
            players,
            competitorType: 'D',
            score: item.teamScore,
            team_id: item.teamId,
            team_name: item.teamName,
            team_eng: item.teamNameEn,
            team_logo: item.teamLogo,
            score_detail,
            // playerList: ['马努什·乌特帕尔拜', ''],
          }
          dataArr.push(baseItem)
        })
        // let home = {
        //   players: data.objectInfo[0].playerInfos,
        //   score: data.objectInfo[0].teamScore,
        //   team_id: data.objectInfo[0].teamId,
        //   team_name: data.objectInfo[0].teamName,
        //   team_eng: data.objectInfo[0].teamNameEn,
        //   team_logo: data.objectInfo[0].teamLogo,
        //   score_detail: [
        //     {
        //       periodCode: 'G1',
        //       periodName: '第1局',
        //       score: 0,
        //       periodScore: 8,
        //     },
        //     {
        //       periodCode: 'G2',
        //       periodName: '第2局',
        //       score: 1,
        //       periodScore: 11,
        //     },
        //     {
        //       periodCode: 'G3',
        //       periodName: '第3局',
        //       score: 1,
        //       periodScore: 6,
        //     },
        //   ],
        // }
        eventCompModeDatas = {
          home: dataArr[0],
          away: dataArr[1],
          // away: {
          //   players: [
          //     {
          //       position: null,
          //       bib_number: '1',
          //       player_id: '2001113',
          //       player_name: '马努什·乌特帕尔拜',
          //       player_logo:
          //         'https://hyper-sports-res.mixtmt.com/Games/ASG19/participants/TTE/2001113.jpg',
          //       player_gender: 'M',
          //       birth_date: '2001-01-12',
          //       is_starter: false,
          //       is_captain: false,
          //       team_id: 'IND',
          //       team_name: '印度',
          //       team_logo:
          //         'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/IND.png',
          //       competitor_code: 'TTEMDOUBLES----IND2',
          //       is_coach: false,
          //       unit_code: 'TTEMDOUBLES-----------R64-000600--',
          //     },
          //     {
          //       position: null,
          //       bib_number: '2',
          //       player_id: '2001001',
          //       player_name: '马纳夫·维卡什',
          //       player_logo:
          //         'https://hyper-sports-res.mixtmt.com/Games/ASG19/participants/TTE/2001001.jpg',
          //       player_gender: 'M',
          //       birth_date: '2000-04-14',
          //       is_starter: false,
          //       is_captain: false,
          //       team_id: 'IND',
          //       team_name: '印度',
          //       team_logo:
          //         'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/IND.png',
          //       competitor_code: 'TTEMDOUBLES----IND2',
          //       is_coach: false,
          //       unit_code: 'TTEMDOUBLES-----------R64-000600--',
          //     },
          //   ],
          //   score: 3,
          //   team_id: 'IND',
          //   team_name: '印度',
          //   team_eng: 'India',
          //   team_logo:
          //     'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/IND.png',
          //   is_win: '胜',
          //   score_detail: [
          //     {
          //       periodCode: 'G1',
          //       periodName: '第1局',
          //       score: 1,
          //       periodScore: 11,
          //     },
          //     {
          //       periodCode: 'G2',
          //       periodName: '第2局',
          //       score: 1,
          //       periodScore: 8,
          //     },
          //     {
          //       periodCode: 'G3',
          //       periodName: '第3局',
          //       score: 2,
          //       periodScore: 11,
          //     },
          //   ],
          //   // playerList: ['马努什·乌特帕尔拜', '马纳夫·维卡什'],
          // },
          table_head: [
            {
              name: '竞赛者',
              desc: null,
              map_key_arr: ['team_name', 'team_logo'],
            },
            {
              name: '得分',
              desc: null,
              map_key_arr: ['score'],
            },
          ],
        }
      }

      console.debug('computedMatchList:', eventCompModeDatas)
      return eventCompModeDatas
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_mode_6 {
  width: 100%;
}
</style>
